<template>
  <img
    class="object-contain w-full"
    alt="Payje logo"
    src="@/assets/image/logo-payje.svg"
  />
</template>